<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单需求</div>
				<div class="menuItem">参考照片</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="checkDownload">
				<div class="check" v-if="!checkAll && (activeCategory == 0 || activeCategory == 4)"
					@click="changeAllWork(true)">全选</div>
				<div class="check" v-if="checkAll" @click="changeAllWork(false)">取消全选</div>
				<div class="download" v-if="checkAll" @click="downloadAll">
					<img class="icon" src="../assets/MyOrder/iconC.png" />
					一键下载
				</div>
			</div>
			<div class="orderList" v-if="orderList.length">
				<div class="orderItem" v-for="(item,index) in orderList" :key="index">
					<div class="orderItemTop">
						<div class="timeNoDetails">
							<div class="time">{{item.create_time}}</div>
							<div class="no">订单号: {{item.order_sn}}</div>
							<div class="details" @click="naviToDetails(item)">订单详情<img class="arrow"
									src="../assets/MyOrder/iconD.png" /></div>
							<div class="details" style="color: #706614;"
								@click="curOrder = item;dialogEvaluateVisible = true" v-if="item.status == 4">
								{{!item.pj_status ? '去评价' : '查看评价'}}<img class="arrow"
									src="../assets/MyOrder/iconG.png" />
							</div>
						</div>
						<div class="countdownStatus">
							<div class="status">{{getStatusName(item)}}</div>
						</div>
					</div>
					<div class="orderItemBottom">
						<div class="checkImgGoodsInfoBox">
							<img class="checkImg" src="../assets/Register/checkSel.png"
								v-if="checkAll && item.check && item.status == 4" @click="item.check = false" />
							<img class="checkImg" src="../assets/Register/checkNor.png"
								v-if="checkAll && !item.check && item.status == 4" @click="item.check = true" />
							<img class="checkImg" src="../assets/Register/checkDisable.png"
								v-if="checkAll && item.status != 4" />
							<div class="goodsInfoBox">
								<div class="goodsInfo">
									<div class="goodsDesc ellipsis-3">{{item.content}}</div>
									<div class="tips">
										<div class="tip">{{item.yongtu_name}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="image-gallery">
							<ImgAallery :images="item.img" v-if="item.img && item.img.length" />
						</div>
						<div class="operation">
							<div class="download" v-if="item.status == 4" @click="downloadImages(item.yt_img)">下载图片
							</div>
							<div class="apply" v-if="item.status == 4 && item.invoice == 0" @click="applyInvoice(item)">
								<img src="../assets/MyOrder/iconB.png">
								申请发票
							</div>
							<div class="payNow" v-if="item.status == 2" @click="naviToDetails(item)">立即支付</div>
							<div class="cancel" v-if="item.status == 1 || item.status == 2" @click="cancelOrder(item)">
								取消订单</div>
							<div class="delete" v-if="item.status == 5" @click="deleteOrder(item)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination v-if="total > 0" style="padding: .2rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body
			@close="dialogReportVisible = false">
			<div slot="title">
				<div class="dislogTitle">
					物流信息
				</div>
			</div>
			<div class="dislogConent">
				<div>快递名称：{{}}</div>
				<div>快递单号：{{}}</div>
				<div>备注信息：{{}}</div>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					支付二维码
				</div>
			</div>
			<div class="dislogConent" style="display: flex;justify-content: center;">
				<img :src="payUrl" style="width: 2rem;height: 2rem;" />
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<EvaluateDialog :show="dialogEvaluateVisible" @close="dialogEvaluateVisible = false" :orderData="curOrder"
			@update="makeOrder" />
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :type="3" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;makeOrder()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'" @clickOk="sucPop = false"
			v-if="sucPop" />
		<div v-if="showProgress" style="margin-top: 20px; width: 400px;">
			<el-progress :percentage="progress"></el-progress>
		</div>
	</div>
</template>

<script>
	import JSZip from "jszip";
	import QRCode from 'qrcode';
	import {
		saveAs
	} from "file-saver";
	import PopToast from '../components/PopToast.vue'
	import ImgAallery from '../components/ImgAallery.vue'
	import EvaluateDialog from '../components/EvaluateDialog.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'

	export default {
		components: {
			PopToast,
			ImgAallery,
			EvaluateDialog,
			ApplyInvoiceDialog
		},
		data() {
			return {
				imgList: [],
				concurrency: 5, // 并发下载数量
				maxZipSize: /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 300 * 1024 * 1024 : 500 * 1024 * 1024,
				progress: 0, // 总进度百分比
				showProgress: false,
				dialogEvaluateVisible: false,
				orderId: '',
				timer: null,
				payUrl: '',
				orderList: [],
				// 分类导航
				categories: [{
						key: '0',
						name: '全部'
					},
					{
						key: '1',
						name: '画师待确认'
					},
					{
						key: '2',
						name: '待支付'
					},
					{
						key: '3',
						name: '创作中'
					},
					{
						key: '4',
						name: '已完成'
					},
					{
						key: '5',
						name: '已取消'
					}
				],
				checkAll: false,
				curOrder: {},
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				scrollPosition: 0,
				thumbnailsPerPage: 3,
				activeCategory: '0',
				sucPop: false,
				dialogApplyInvoiceViable: false,
				dialogReportVisible: false,
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			this.makeOrder()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			formatThreeDigits(num) {
				return num.toString().padStart(3, '0');
			},
			// async downloadZip() {
			// 	this.showProgress = true;
			// 	this.progress = 0;

			// 	const loading = this.$loading({
			// 		lock: true,
			// 		text: "准备中...",
			// 		spinner: "el-icon-loading",
			// 		background: "rgba(0,0,0,0.7)"
			// 	});

			// 	// 分卷 zip 列表
			// 	let zipIndex = 1;
			// 	let currentZip = new JSZip();
			// 	let currentFolder = currentZip.folder("images");
			// 	let currentZipSize = 0; // 当前 zip 大小累计

			// 	let completed = 0;

			// 	try {
			// 		// --------------------------
			// 		// 并发控制器
			// 		// --------------------------
			// 		const parallel = async (list, limit, iteratorFn) => {
			// 			const ret = [];
			// 			const executing = [];
			// 			for (const item of list) {
			// 				const p = Promise.resolve().then(() => iteratorFn(item));
			// 				ret.push(p);

			// 				if (executing.length >= limit) {
			// 					await Promise.race(executing);
			// 				}

			// 				const e = p.then(() =>
			// 					executing.splice(executing.indexOf(e), 1)
			// 				);
			// 				executing.push(e);
			// 			}
			// 			return Promise.all(ret);
			// 		};

			// 		// --------------------------
			// 		// 自动重试（3 次）
			// 		// --------------------------
			// 		const fetchWithRetry = async (url, retry = 3) => {
			// 			for (let i = 0; i < retry; i++) {
			// 				try {
			// 					const res = await fetch(url);
			// 					if (!res.ok) throw new Error("fetch失败");
			// 					return await res.blob();
			// 				} catch (e) {
			// 					console.warn(`❌ 图片下载失败，重试 ${i + 1} 次：${url}`);
			// 				}
			// 			}
			// 			throw new Error("三次失败");
			// 		};

			// 		// --------------------------
			// 		// 下载图片逻辑
			// 		// --------------------------
			// 		const downloadImage = async (url) => {
			// 			const index = this.imgList.indexOf(url);
			// 			loading.text = `下载中 ${index + 1}/${this.imgList.length} ...`;

			// 			try {
			// 				const blob = await fetchWithRetry(url);

			// 				// 自动识别扩展名
			// 				let ext = url.split(".").pop().split("?")[0];
			// 				if (!ext || ext.length > 5) ext = "jpg"; // fallback

			// 				const originalName = url.split("/").pop().split("?")[0];
			// 				const fixedName = "daiyuart" + this.formatThreeDigits(index + 1);
			// 				const extension = originalName.includes(".") ? originalName.split(".").pop() : "";
			// 				const newFileName = extension ? `${fixedName}.${extension}` : fixedName;
			// 				const file = new File([blob], newFileName, {
			// 					type: blob.type
			// 				});
			// 				console.log(file)
			// 				// 分卷判断：当前 zip 大小达到 500MB → 自动另起一个 ZIP
			// 				currentZipSize += blob.size;

			// 				if (currentZipSize > this.maxZipSize) {
			// 					await this.saveZip(currentZip, zipIndex);
			// 					zipIndex++;

			// 					currentZip = new JSZip();
			// 					currentFolder = currentZip.folder("images");
			// 					currentZipSize = 0;
			// 				}

			// 				// 添加文件到 ZIP
			// 				currentFolder.file(newFileName, blob);

			// 			} catch (e) {
			// 				console.warn("图片多次失败，自动跳过：", url);
			// 			}

			// 			completed++;
			// 			this.progress = Math.floor((completed / this.imgList.length) * 100);
			// 		};

			// 		// --------------------------
			// 		// 执行下载并限制并发
			// 		// --------------------------
			// 		await parallel(this.imgList, this.concurrency, downloadImage);

			// 		// 保存最后一个 zip
			// 		await this.saveZip(currentZip, zipIndex);

			// 	} catch (e) {
			// 		this.$message.error("下载失败：" + e.message);
			// 	} finally {
			// 		loading.close();
			// 		this.showProgress = false;
			// 	}
			// },

			// // --------------------------
			// // 保存 ZIP 为文件
			// // --------------------------
			// async saveZip(zip, index) {
			// 	console.log(index)
			// 	const blob = await zip.generateAsync({
			// 			type: "blob"
			// 		},
			// 		(progress) => {
			// 			this.progress = Math.floor(progress.percent);
			// 		}
			// 	);
			// 	const fileName = `${Date.now()}.zip`;
			// 	saveAs(blob, fileName);
			// },
			async downloadZip() {
				this.showProgress = true;
				this.progress = 0;

				const loading = this.$loading({
					lock: true,
					text: "准备中...",
					spinner: "el-icon-loading",
					background: "rgba(0,0,0,0.7)"
				});

				// --------------------------
				// iOS 判断（核心）
				// --------------------------
				const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
				const concurrency = isIOS ? 1 : this.concurrency;

				// --------------------------
				// zip 分卷参数
				// --------------------------
				let zipIndex = 1;
				let currentZip = new JSZip();
				let currentFolder = currentZip.folder("images");
				let currentZipSize = 0;

				let completed = 0;

				try {
					// --------------------------
					// 并发控制器
					// --------------------------
					const parallel = async (list, limit, iteratorFn) => {
						const ret = [];
						const executing = [];

						for (const item of list) {
							const p = Promise.resolve().then(() => iteratorFn(item));
							ret.push(p);

							if (limit <= list.length) {
								const e = p.then(() => executing.splice(executing.indexOf(e), 1));
								executing.push(e);

								if (executing.length >= limit) {
									await Promise.race(executing);
								}
							}
						}

						return Promise.all(ret);
					};

					// --------------------------
					// fetch 自动重试
					// --------------------------
					const fetchWithRetry = async (url, retry = 3) => {
						for (let i = 0; i < retry; i++) {
							try {
								const res = await fetch(url, {
									cache: "no-store"
								});
								if (!res.ok) throw new Error("fetch 失败");

								const blob = await res.blob();
								if (!blob || blob.size === 0) {
									throw new Error("空 blob");
								}

								return blob;
							} catch (e) {
								console.warn(`❌ 下载失败，重试 ${i + 1} 次`, url);
								await new Promise(r => setTimeout(r, 300));
							}
						}
						throw new Error("三次下载失败");
					};

					// --------------------------
					// 单张图片下载
					// --------------------------
					const downloadImage = async (url) => {
						const index = this.imgList.indexOf(url);
						loading.text = `下载中 ${index + 1}/${this.imgList.length}`;

						try {
							const blob = await fetchWithRetry(url);

							// 自动文件名
							const originalName = url.split("/").pop().split("?")[0];
							const ext = originalName.includes(".") ?
								originalName.split(".").pop() :
								"jpg";

							const newFileName = `daiyuart_${this.formatThreeDigits(index + 1)}.${ext}`;

							// ⚠️ 先判断是否超出 zip 体积
							if (currentZipSize + blob.size > this.maxZipSize) {
								await this.saveZip(currentZip, zipIndex);
								zipIndex++;

								currentZip = new JSZip();
								currentFolder = currentZip.folder("images");
								currentZipSize = 0;
							}

							currentFolder.file(newFileName, blob);
							currentZipSize += blob.size;

						} catch (e) {
							console.warn("🚫 图片跳过：", url);
						}

						completed++;
						this.progress = Math.floor((completed / this.imgList.length) * 100);
					};

					// --------------------------
					// 执行下载
					// --------------------------
					await parallel(this.imgList, concurrency, downloadImage);

					// 保存最后一个 zip
					await this.saveZip(currentZip, zipIndex);

				} catch (e) {
					this.$message.error("下载失败：" + e.message);
				} finally {
					loading.close();
					this.showProgress = false;
				}
			},

			// --------------------------
			// 保存 ZIP 为文件
			// --------------------------
			async saveZip(zip, index) {
				if (!zip || Object.keys(zip.files).length === 0) return;

				const blob = await zip.generateAsync({
						type: "blob",
						streamFiles: true
					},
					progress => {
						this.progress = Math.floor(progress.percent);
					}
				);

				if (!blob || blob.size === 0) {
					console.warn("❌ 生成 zip 失败（空文件）", index);
					return;
				}

				const fileName = `images_${index}_${Date.now()}_${Math.random().toString(36).slice(2)}.zip`;

				// iOS 必须延迟
				await new Promise(r => setTimeout(r, 100));

				saveAs(blob, fileName);
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.makeOrder()
			},
			downloadAll() {
				const imgages = this.orderList.filter(v => v.check == true && v.pay_status == 1 && v.status == 4 && v
					.yt_img).map(v => v.yt_img);
				this.downloadImages([].concat(...imgages))
			},
			getFileNameFromUrl(url) {
				// 从 URL 中提取文件名
				return url.substring(url.lastIndexOf('/') + 1);
			},
			downloadImages(imageList) {
				this.imgList = imageList
				const ua = navigator.userAgent || navigator.vendor || window.opera;

				const isIOS = /iP(ad|hone|od)/.test(ua);
				const isAndroid = /Android|Adr/i.test(ua);
				const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS/i.test(ua); // iOS Safari 独立判断
				const isWeChat = /MicroMessenger/i.test(ua);

				if (isIOS && !isSafari) {
					// iOS 非 Safari 浏览器
					this.$message.info("请复制链接，使用 Safari 打开页面下载");
					console.warn("请在 Safari 打开下载 ZIP");
				} else if (isAndroid && isWeChat) {
					// 安卓微信浏览器
					this.$message.info("微信浏览器无法直接下载，请使用其他浏览器下载");
					console.warn("请使用其他浏览器下载 ZIP");
				} else {
					// PC / 安卓其他浏览器 / iOS Safari
					this.downloadZip()
				}
			},
			// async downloadImages(imageList) {
			// 	for (let i = 0; i < imageList.length; i++) {
			// 		const url = imageList[i];
			// 		try {
			// 			// 使用 fetch 获取原图 Blob
			// 			const response = await fetch(url, {
			// 				mode: 'cors'
			// 			});
			// 			const blob = await response.blob();

			// 			// 创建临时 a 标签下载
			// 			const link = document.createElement('a');
			// 			link.href = URL.createObjectURL(blob);
			// 			link.download = this.getFileNameFromUrl(url); // 使用原始文件名
			// 			document.body.appendChild(link);
			// 			link.click();
			// 			document.body.removeChild(link);

			// 			// 释放对象 URL
			// 			URL.revokeObjectURL(link.href);
			// 		} catch (err) {
			// 			console.error('下载失败', url, err);
			// 		}
			// 	}
			// },
			//申请发票
			applyInvoice(item) {
				this.curOrder = item
				this.dialogApplyInvoiceViable = true
			},
			getStatusName(item) {
				if (item.status == 1) {
					return '画师待确认'
				} else if (item.status == 2) {
					return '待支付'
				} else if (item.status == 3) {
					return '创作中'
				} else if (item.status == 4) {
					return '已完成'
				} else if (item.status == 5) {
					return item.out_refund_no ? '已退款' : '已取消'
				}
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 2,
						orderId: item.id
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.checkAll = false
				this.makeOrder()
			},
			changeAllWork(isAll) {
				this.checkAll = isAll
				this.orderList.map(item => item.check = true)
			},
			makeOrder() {
				this.orderList = []
				this.$api.post('/Hua/dz_order_list', {
					status: this.activeCategory,
					p: this.currentPage,
					type: 1,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.forEach(item => {
							this.orderList.push({
								...item,
								check: true
							})
						})
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//取消订单
			cancelOrder(item) {
				this.$confirm('确认取消当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/dz_order_cancel', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.makeOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//删除订单
			deleteOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/dz_order_del', {
						id: item.id,
						type: 1,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.makeOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			patOrder(item) {
				this.submitOrder(item.id)
			},
			submitOrder(orderId) {
				this.$api.post('/Tonglian/dz_nativepay', {
					id: orderId,
				}).then(res => {
					if (res.code == 1) {
						this.orderId = orderId
						this.generateQRCode(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			generateQRCode(text) {
				let that = this
				QRCode.toDataURL(text, function(error, url) {
					that.payUrl = url
					that.dialogReportVisible = true
					that.timer = setInterval(() => {
						that.checkOrder()
					}, 5000)
				});
			},
			checkOrder() {
				this.$api.post('/Notify/check_order', {
					order_id: this.orderId,
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.dialogReportVisible = false
						this.$message.success(res.msg)
						clearInterval(this.timer);
						this.timer = null
						//去订单列表
					}
				}).catch(err => {
					console.log(err);
				})
			},
			handleClose() {
				this.dialogReportVisible = false
				clearInterval(this.timer);
				this.timer = null
			},
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 4rem;
			}

			.menuItem:nth-child(2) {
				width: 3.55rem;
			}

			.menuItem:nth-child(3) {
				width: 1.2rem;
			}
		}

		.checkDownload {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .16rem;

			.check {
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				cursor: pointer;
			}

			.download {
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #A88653;
				cursor: pointer;

				.icon {
					margin-right: .04rem;
					width: .14rem;
					height: .14rem;
				}
			}
		}

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			.orderItem {
				display: flex;
				flex-direction: column;

				.orderItemTop {
					height: .4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 .16rem;
					background: #FAEFDD;
					border-radius: .04rem;

					.timeNoDetails {
						display: flex;
						align-items: center;

						.time,
						.no {
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
						}

						.no {
							margin-left: .16rem;
						}

						.details {
							margin-left: .16rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #A88653;
							cursor: pointer;

							.arrow {
								margin-left: .04rem;
								width: .05rem;
								height: .08rem;
							}
						}
					}

					.countdownStatus {
						display: flex;
						align-items: center;

						.countdown {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #252525;

							div {
								margin-left: .02rem;
								margin-right: .02rem;
								width: .22rem;
								height: .22rem;
								background: #E29358;
								border-radius: .04rem;
								line-height: .22rem;
								text-align: center;
								font-weight: 500;
								font-size: .12rem;
								color: #252525;
							}
						}

						.status {
							margin-left: .16rem;
							font-weight: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.orderItemBottom {
					padding: .12rem 0 .24rem;
					display: flex;
					align-items: center;

					.checkImgGoodsInfoBox {
						width: 4rem;
						display: flex;
						align-items: center;

						.checkImg {
							width: .18rem;
							height: .18rem;
						}

						.goodsInfoBox {
							display: flex;
							align-items: center;

							.goodsImg {
								width: 1rem;
								height: 1rem;
								border-radius: .08rem;
								overflow: hidden;
								object-fit: cover;
							}

							.goodsInfo {
								width: 2.4rem;
								margin-left: .16rem;
								display: flex;
								flex-direction: column;

								.goodsTitle {
									font-weight: 700;
									font-size: .16rem;
									color: #000000;
									line-height: .22rem;
								}

								.goodsDesc {
									margin-top: .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #333333;
									line-height: .16rem;
								}

								.tips {
									margin-top: .12rem;
									display: flex;
									align-items: center;

									.tip {
										height: .26rem;
										padding: 0 .08rem;
										border-radius: .13rem;
										border: .01rem solid #A88653;
										line-height: .24rem;
										font-weight: 400;
										font-size: .12rem;
										color: #7C3E0B;
									}
								}
							}
						}
					}


				}

				.image-gallery {
					width: 3.55rem;
				}

				.operation {
					width: 1.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					.download,
					.payNow {
						width: .88rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}

					.apply {
						margin-top: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						cursor: pointer;

						img {
							margin-right: .04rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.cancel {
						margin-top: .12rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
					}

					.delete {
						width: .88rem;
						height: .36rem;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>